import { Deserializable } from '../deserializable';

export class LookupBanks implements Deserializable {
  id: number;
  name: string;
  branch: string;
  outOfTerritory: boolean;
  aliases: string;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  GetBankById(id: number) {
    if (id == 7) {
      var bank = new LookupBanks();
      bank.id = 7;
      bank.name = 'Capitec Business';
      bank.branch = '450105';
      bank.outOfTerritory = false;
      bank.aliases = 'Capitec, Capitec Bank, Mercantile Bank, Mercantile';

      return bank;
    } else {
      return this;
    }
  }
}
